module.exports = __webpack_public_path__ + "img/img20.066cf58a.png";